import { useState } from "react";
import { FMFile } from "../shared/FMFile";
import Confirm from "./Confirm";
import { Checkbox, FormControlLabel } from "@mui/material";

export default function ConfirmDelete(props:{files:FMFile[],onConfirm:any}) {
    const {files} = props
    const [recursive,setRecursive] = useState<boolean>(false)
    
    const onRecursive = (e:any) => setRecursive(e.target.checked)
    const onConfirm = () => props.onConfirm(files, recursive)
    const recursiveToggle = files.find(file => FMFile.isDir(file)) ? <FormControlLabel control={<Checkbox onChange={onRecursive}/>} label="Delete all contents and sub-directories"/> : null
    const filenames = files.map(file => file.name).join(", ")
    return <Confirm message={`Are you sure you wish to delete ${filenames}`} onConfirm={onConfirm}>{recursiveToggle}</Confirm>
}